import React from 'react'

function Footer() {
  return (
    <div className="bg-success p-4 text-center">

        <p className='text-white'>Todos los derechos reservados Carbono Zero 2023.</p>
    </div>
  )
}

export default Footer